exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Responsive helper\n */\n.trip-frame[data-v-9fb9e95c] {\n  height: 209px;\n  width: 100%;\n}\n@media (max-width: 768px) {\n.trip-frame[data-v-9fb9e95c] {\n    display: none;\n}\n}\n.trip-frame-md[data-v-9fb9e95c] {\n  display: none;\n}\n@media (max-width: 768px) {\n.trip-frame-md[data-v-9fb9e95c] {\n    height: 300px;\n    display: unset;\n}\n}", ""]);

// exports
